import * as cx from 'classnames';
import { LocationDescriptor } from 'history';
import Link from 'mk2/components/Link';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import * as React from 'react';
import styles from './LinkListItem.mscss';

export enum GrowPriority {
    title = 'title',
    subtitle = 'subtitle',
}

interface OwnProps {
    className?: string;
    title: React.ReactNode;
    to: LocationDescriptor;
    priority?: GrowPriority;
    icon?: React.ReactNode;

    onClick?();
}

type Props = OwnProps;

const LinkListItem: React.StatelessComponent<Props> = ({ className, to, title, children, priority = GrowPriority.title, onClick, icon }) => (
    <li className={cx(styles.LinkListItem, className)}>
        <Link
            className={cx(styles.LinkListItem__link, icon && styles['LinkListItem__link--customIcon'])}
            to={to}
            onClick={onClick}
        >
            {icon && (
                <div className={styles.LinkListItem__link__icon}>
                    {icon}
                </div>
            )}
            <span className={cx(styles.LinkListItem__link__title, styles[`LinkListItem__link__title--${priority}Priority`], icon && styles['LinkListItem__link__title--customIcon'])}>
                {title}
            </span>

            {React.Children.count(children) > 0 && (
                <span className={cx(styles.LinkListItem__link__subtitle, styles[`LinkListItem__link__subtitle--${priority}Priority`])}>
                    {children}
                </span>
            )}
        </Link>
    </li>
);

LinkListItem.displayName = 'LinkListItem';

export default LinkListItem;

interface PlaceholderOwnProps {
    className?: string;
    width?: number | string;
}

export const LinkListItemPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ className, width }) => (
    <li className={cx(styles.LinkListItem, className)}>
        <span className={cx(styles.LinkListItem__link, styles['LinkListItem__link--placeholder'])}>
            <LoadingPlaceholder
                className={cx(styles.LinkListItem__link__title, styles[`LinkListItem__link__title--titlePriority`])}
                width={width}
                height={13}
            />
        </span>
    </li>
);

LinkListItemPlaceholder.displayName = 'LinkListItemPlaceholder';
